import React from 'react';
import styled from 'styled-components';
import SmallTitle from './SmallTitle';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import SchoolIcon from '@mui/icons-material/School';
import ResumeItem from './ResumeItem';

const ResumeStyled = styled.section`
    margin-top: 60px;
    .small-title{
        padding-bottom: 3rem;
    }
    .u-small-title-margin{
        margin-top: 4rem;
    }

    .resume-content{
        border-left: 2px solid var(--border-color);
    }
`;

function Resume() {

    return (
        <ResumeStyled>
            <div className="small-title">
                <SmallTitle icon={<BusinessCenterIcon />} title={'Working Experience'} />
            </div>
            <div className="resume-content">
                <ResumeItem
                    year={'Dec 2021 - Present'}
                    title={'Perennial Systems'}
                    subTitle={'Full Stack Web Developer'}
                />
            </div>
            <div className="small-title u-small-title-margin">
                <SmallTitle icon={<SchoolIcon />} title={'Educational Qualifications'} />
            </div>
            <div className="resume-content ">
                <ResumeItem
                    year={'Mar 2021 - Nov 2021'}
                    title={'Full Stack Web Development'}
                    subTitle={'Masai School'}
                />
                <ResumeItem
                    year={'Aug 2016 - Aug 2019'}
                    title={'Diploma in Computer Science & Engineering'}
                    subTitle={'Govt. Polytechnic Shahjahanpur'}
                />
                <ResumeItem
                    year={'July 2012 - May 2014'}
                    title={'Intermediate'}
                    subTitle={'Nehru Adarsh I C Alapur Budaun'}
                />
                {/* <ResumeItem
                    year={'July 2010 - June 2012'}
                    title={'HighSchool'}
                    subTitle={'Ahiliya B S H S S Budaun'}
                /> */}
            </div>
        </ResumeStyled>
    )
}

export default Resume